if (!customElements.get("hero-carousel")) {class HeroCarousel extends HTMLElement {
  constructor() {
    super();

    const splideElement = this.querySelector(".splide");
    if (!splideElement) return;

    const splideId = splideElement.getAttribute("id");
    const autoplaySpeed = parseInt(this.dataset.autoplaySpeed || "5000", 10);
    const autoplay = this.dataset.autoplay === "true";
    const infinite = this.dataset.infinite === "true";

    document.addEventListener("DOMContentLoaded", () => {
      this.splide = new Splide("#" + splideId, {
        type: "fade",
        rewind: infinite,
        perPage: 1,
        perMove: 1,
        autoplay: autoplay,
        interval: autoplaySpeed,
        pauseOnHover: false,
        pauseOnFocus: false,
        pagination: true,
        arrows: false,
        drag: true,
        snap: true,
        speed: 600,
      });

      this.splide.mount();

      const btnPrev = this.querySelector(".hero-carousel__nav-btn--prev");
      const btnNext = this.querySelector(".hero-carousel__nav-btn--next");

      if (btnPrev) {
        btnPrev.addEventListener("click", () => this.splide.go("<"));
      }
      if (btnNext) {
        btnNext.addEventListener("click", () => this.splide.go(">"));
      }

      const updateButtons = () => {
        if (infinite) return;
        const index = this.splide.index;
        const last = this.splide.length - 1;
        if (btnPrev) btnPrev.disabled = index === 0;
        if (btnNext) btnNext.disabled = index === last;
      };

      updateButtons();
      this.splide.on("moved", updateButtons);

      // Show native controls for users with reduced motion
      const prefersReducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      ).matches;
      if (prefersReducedMotion) {
        this.querySelectorAll("video").forEach((v) => {
          v.controls = true;
          v.removeAttribute("autoplay");
          v.pause();
        });
      }
    });
  }
}


  customElements.define("hero-carousel", HeroCarousel);
}